import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'

const Gallery = () => {
  return (
    <div>
      <h3 className='text-center mt-5 mb-5' >Our Gallery</h3>
      <Container className='Gallery_Box mb-5'>
        <Row className=' d-flex justify-content-around mt-5 mb-5'>
          <h5 className='text-center mb-5' >Regalia Of Dexterity</h5>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/ROD (2).jpeg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/ROD (1).jpeg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/ROD (3).jpeg')} />
          </Col>
        </Row>
        <Row className=' d-flex justify-content-around mt-5 mb-5'>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/ROD (4).jpeg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/ROD (5).jpeg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/images (1).jpg')} />
          </Col>
        </Row>
      </Container>
      <Container className='Gallery_Box mb-5' >
        <Row className='d-flex justify-content-around mt-5 mb-5'>
          <h5 className='text-center mb-5' >Our Infrastructure</h5>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/School Image.jpg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/images (6).jpg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/images (3).jpg')} />
          </Col>
        </Row>
        <Row className='d-flex justify-content-around mt-5 mb-5'>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/Bio Lab (1).jpeg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/images (3).jpg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/DSC_0785.JPG')} />
          </Col>
        </Row>
        <Row className='d-flex justify-content-around mt-5 mb-5'>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/Computer Lab.jpg')} />
          </Col>
          <Col md={3}>
            <Image fluid rounded src={require('../../Images/Our School 3.jpeg')} />
          </Col>
          <Col md={3}>
          </Col>
        </Row>
      </Container>
      <Container className='Gallery_Box mb-5'>
        <Row className='d-flex justify-content-around mt-5 mb-5'>
          <h5 className='text-center mb-5' >Our Activities</h5>
          <Col md={3} >
            <Image fluid rounded src={require('../../Images/images (2).jpg')} />
          </Col>
          <Col md={3} >
            <Image fluid rounded src={require('../../Images/Exibhiton.jpeg')} />
          </Col>
          <Col md={3} >
            <Image fluid rounded src={require('../../Images/Student Sansad Pic.jpeg')} />
          </Col>
        </Row>
      </Container>
      <Container className='Gallery_Box mb-5'>
        <Row className='d-flex justify-content-around mt-5 mb-5' >
          <h5 className='text-center mb-5'>Co-Curricular Events</h5>
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/co-curricular (1).jpg')} />
          </Col>
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/co-curricular (2).jpg')} />
          </Col>
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/co-curricular (3).jpg')} />
          </Col>
        </Row>
        <Row className='d-flex justify-content-around mt-5 mb-5' >
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/co-curricular (4).jpg')} />
          </Col>
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/co-curricular (5).jpg')} />
          </Col>
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/images (4).jpg')} />
          </Col>
        </Row>
      </Container>
      <Container className='Gallery_Box mb-5'>
        <Row className='d-flex justify-content-around mt-5 mb-5'>
          <h5 className='text-center mb-5'>Other Services</h5>
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/other Services (1).jpg')} />
          </Col>
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/other Services (2).jpg')} />
          </Col>
          <Col md={3}>
            <Image rounded fluid src={require('../../Images/other Services (3).jpg')} />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Gallery